import { Link } from '@tanstack/react-router';
import { PDF_UPLOAD_TEXTS, type PdfUploadState } from '../lib/pdf-order-upload.ts';
import { cn } from '../lib/utils.ts';
import { ORDER_NEW_PATH } from '../navigation.ts';

/**
 * Stand des Hochladens als Satz (role=status bzw. alert); bei Erfolg mit Link zum Entwurf. Eigene Datei, weil die
 * Ablage auf jeder Seite (`PdfDropHost` im Startgerüst) sie zeigt: so lädt der Start nicht die Auftragsseiten mit.
 */
export function PdfUploadStatus({ state, className }: { state: PdfUploadState; className?: string }) {
  if (state.kind === 'idle') return null;
  if (state.kind === 'error') {
    return (
      <p role="alert" className={cn('type-meta rounded-tile bg-clarify-bg px-space-4 py-space-3 text-clarify', className)} data-testid="pdf-upload-status">
        {state.text}
      </p>
    );
  }
  return (
    <p role="status" className={cn('type-meta rounded-tile bg-tile px-space-4 py-space-3 text-ink-2', className)} data-testid="pdf-upload-status">
      {state.kind === 'sending' ? PDF_UPLOAD_TEXTS.sending : state.kind === 'reading' ? (state.pollFailed ? PDF_UPLOAD_TEXTS.pollFailed : PDF_UPLOAD_TEXTS.reading) : PDF_UPLOAD_TEXTS.created(state.orderNumber)}
      {state.kind === 'created' ? (
        <>
          {' '}
          <Link to="/auftraege/$id" params={{ id: state.orderId }} className="text-ink underline underline-offset-2">
            {PDF_UPLOAD_TEXTS.open}
          </Link>
          {' · '}
          <Link to={ORDER_NEW_PATH} search={{ pdf: state.orderId }} className="text-ink underline underline-offset-2">
            {PDF_UPLOAD_TEXTS.review}
          </Link>
        </>
      ) : null}
    </p>
  );
}
